let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("g38XK")]).then(() => parcelRequire('fnE71'));